import { queryClient } from '../../../../App';
import { AlertWithTimestamp } from '../../../../components/AlertWithTimestamp';
import { extractApiErrorMessage } from '../../../../utils/extractApiErrorMessage';

const DEFAULT_SAVE_FAILURE_MESSAGE = 'Não foi possível salvar a alteração.';

/**
 * Trata a recusa do backend ao salvar um item da negociação: exibe a mensagem
 * de negócio vinda do corpo da resposta (ou um texto fixo de recuo quando o
 * formato não é o esperado) e recarrega os dois dados que a tela depende para
 * refletir o estado real da negociação, em vez de manter a edição digitada.
 */
export async function notifyItemSaveFailure(error: unknown): Promise<void> {
  const errorMessage = extractApiErrorMessage(error);

  AlertWithTimestamp({ message: errorMessage ?? DEFAULT_SAVE_FAILURE_MESSAGE });

  await queryClient.refetchQueries(['negotiation/get-details']);
  await queryClient.refetchQueries(['get-negotiation-datapoints']);
}
